import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { Integrator, IntegratorDetails, IntegratorListQuery } from './types'

export const fetchIntegratorList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: IntegratorListQuery }) => {
  return wretchClient
    .url('/admin/1.0/integrators')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<Integrator>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const fetchIntegratorDetails = async (params?: { abortCtrl?: AbortController | AbortSignal, id: string }) => {
  return wretchClient
    .url(`/admin/1.0/integrators/${params?.id}`)
    .signal(params?.abortCtrl)
    .get()
    .json<[IntegratorDetails]>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addIntegrator = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/integrators`)
    .post(value)
    .json<Integrator>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addHostAdminIntegrator = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/integrators/by-host-admin`)
    .post(value)
    .json<Integrator>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const deleteIntegrator = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/integrators/${id}`)
    .delete()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
